import BarChartIcon from '@mui/icons-material/BarChart';
import BookOnlineSharpIcon from '@mui/icons-material/BookOnlineSharp';
import ContentPasteIcon from '@mui/icons-material/ContentPaste';
import EventIcon from '@mui/icons-material/Event';
import FavoriteIcon from '@mui/icons-material/Favorite';
import HealingIcon from '@mui/icons-material/Healing';
import HomeRoundedIcon from '@mui/icons-material/HomeRounded';
import InsertChartIcon from '@mui/icons-material/InsertChart';
import InventoryIcon from '@mui/icons-material/Inventory';
import LocalPharmacyIcon from '@mui/icons-material/LocalPharmacy';
import MedicalServicesIcon from '@mui/icons-material/MedicalServices';
import PeopleAltIcon from '@mui/icons-material/PeopleAlt';
import PersonAddIcon from '@mui/icons-material/PersonAdd';
import PersonRoundedIcon from '@mui/icons-material/PersonRounded';
import ReceiptLongIcon from '@mui/icons-material/ReceiptLong';
import ScannerIcon from '@mui/icons-material/Scanner';
import ScienceIcon from '@mui/icons-material/Science';
import VaccinesIcon from '@mui/icons-material/Vaccines';
import PregnantWomanIcon from '@mui/icons-material/PregnantWoman';
import BloodtypeIcon from '@mui/icons-material/Bloodtype';
import PaymentsIcon from '@mui/icons-material/Payments';
import VolunteerActivismIcon from '@mui/icons-material/VolunteerActivism';
import PlaylistAddCheckIcon from '@mui/icons-material/PlaylistAddCheck';
import BiotechIcon from '@mui/icons-material/Biotech';
import PublishedWithChangesIcon from '@mui/icons-material/PublishedWithChanges';
import TroubleshootIcon from '@mui/icons-material/Troubleshoot';
import ChildCareIcon from '@mui/icons-material/ChildCare';
import RunningWithErrorsIcon from '@mui/icons-material/RunningWithErrors';
import FactCheckIcon from '@mui/icons-material/FactCheck';
import MonitorHeartIcon from '@mui/icons-material/MonitorHeart';
import HotelIcon from '@mui/icons-material/Hotel';
import QrCode2Icon from '@mui/icons-material/QrCode2';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import AdminPanelSettingsIcon from '@mui/icons-material/AdminPanelSettings';
import $ from 'jquery';
import {useEffect, useState} from 'react';
import {TbReportAnalytics} from 'react-icons/tb';
import {useDispatch, useSelector} from 'react-redux';
import {NavLink, useLocation} from 'react-router-dom';
import {dvtabs, sidebar, sidenav} from '../Redux/Slice/rootSlice';
import '../styles/sidenav.scss';

function SideBar() {
  const sideactive = useSelector(state => state.counter.sidebarnav);
  const userdata = useSelector(state => state.counter.userdata);
  const sidebarstate = useSelector(state => state.counter.sidebar);

  const dispatch = useDispatch();
  const location = useLocation();
  const [expand, setExpand] = useState({});

  // Synchronous safe role resolution
  const userRole = (localStorage.getItem('role') || userdata?.role || '').trim().toLowerCase();
  const isAdmin = userRole === 'admin' || userRole === 'super admin';
  const isDoctor = userRole === 'doctor';
  const isLab = userRole === 'lab';
  const isStaff = userRole === 'staff';

  // Responsive sidebar close on window resize
  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth <= 920) {
        dispatch(sidenav(false));
      }
    };
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, [dispatch]);

  // Sidebar nav items
  const navData = [
    {
      id: 0,
      icon: <HomeRoundedIcon style={{padding: '10px', fontSize: '46px'}} />,
      text: 'DashBoard',
      className: `adminusernav${sidebarstate === 'DashBoard' ? ' activesidemenu' : ''}`,
      link: '/'
    },
    {
      id: 1,
      icon: <PersonRoundedIcon style={{padding: '10px', fontSize: '46px'}} />,
      text: 'Patient Details',
      className: `doctorsidebar${sidebarstate === 'Patient Details' ? ' activesidemenu' : ''}`,
      link: '/Patients'
    },
    {
      id: 3,
      icon: <ReceiptLongIcon style={{padding: '10px', fontSize: '46px'}} />,
      text: 'Patient Billing',
      className: `doctorsidebar${sidebarstate === 'Patient Billing' ? ' activesidemenu' : ''}`,
      link: '/patient_billing'
    },
    {
      id: 31,
      icon: <PaymentsIcon style={{padding: '10px', fontSize: '46px'}} />,
      text: 'IP Billing',
      className: `doctorsidebar${sidebarstate === 'IP Billing' ? ' activesidemenu' : ''}`,
      link: '/ipbilling',
      subMenus: [
        {
          id: 311,
          icon: <ReceiptLongIcon style={{padding: '5px', fontSize: '30px'}} />,
          text: 'New IP Bill',
          className: `doctorsidebar${sidebarstate === 'New IP Bill' ? ' activesidemenu' : ''}`,
          link: '/ipbilling/new'
        },
        {
          id: 312,
          icon: <ContentPasteIcon style={{padding: '5px', fontSize: '30px'}} />,
          text: 'IP Bills',
          className: `doctorsidebar${sidebarstate === 'IP Bills' ? ' activesidemenu' : ''}`,
          link: '/ipbilling/bills'
        },
        {
          id: 313,
          icon: <PlaylistAddCheckIcon style={{padding: '5px', fontSize: '30px'}} />,
          text: 'Packages',
          className: `doctorsidebar${sidebarstate === 'IP Billing Packages' ? ' activesidemenu' : ''}`,
          link: '/ipbilling/packages'
        },
        {
          id: 314,
          icon: <VolunteerActivismIcon style={{padding: '5px', fontSize: '30px'}} />,
          text: 'Add-ons',
          className: `doctorsidebar${sidebarstate === 'IP Billing Add-ons' ? ' activesidemenu' : ''}`,
          link: '/ipbilling/addons'
        },
        {
          id: 315,
          icon: <BarChartIcon style={{padding: '5px', fontSize: '30px'}} />,
          text: 'IP Billing Reports',
          className: `doctorsidebar${sidebarstate === 'IP Billing Reports' ? ' activesidemenu' : ''}`,
          link: '/ipbilling/reports'
        },
        {
          id: 316,
          icon: <PeopleAltIcon style={{padding: '5px', fontSize: '30px'}} />,
          text: 'Doctor Earnings',
          className: `doctorsidebar${sidebarstate === 'Doctor Earnings' ? ' activesidemenu' : ''}`,
          link: '/ipbilling/doctors'
        }
      ]
    },
    {
      id: 4,
      icon: <BookOnlineSharpIcon style={{padding: '10px', fontSize: '46px'}} />,
      text: 'Appointment',
      className: `doctorsidebar${sidebarstate === 'Appointment' ? ' activesidemenu' : ''}`,
      link: '/appointment'
    },
    {
      id: 32,
      icon: <ContentPasteIcon style={{padding: '10px', fontSize: '46px'}} />,
      text: 'Discharge Summary',
      className: `doctorsidebar${sidebarstate === 'Discharge Summary' ? ' activesidemenu' : ''}`,
      link: '/discharge-summary',
      subMenus: [
        {
          id: 321,
          icon: <MedicalServicesIcon style={{padding: '5px', fontSize: '30px'}} />,
          text: 'Hysteroscopy',
          className: `doctorsidebar${sidebarstate === 'Hysteroscopy' ? ' activesidemenu' : ''}`,
          link: '/discharge-summary/hysteroscopy'
        },
        {
          id: 322,
          icon: <HealingIcon style={{padding: '5px', fontSize: '30px'}} />,
          text: 'Cervical Cerclage',
          className: `doctorsidebar${sidebarstate === 'Cervical Cerclage' ? ' activesidemenu' : ''}`,
          link: '/discharge-summary/cervical-cerclage'
        },
        {
          id: 323,
          icon: <ContentPasteIcon style={{padding: '5px', fontSize: '30px'}} />,
          text: 'D&C Procedure',
          className: `doctorsidebar${sidebarstate === 'D&C Procedure' ? ' activesidemenu' : ''}`,
          link: '/discharge-summary/d-and-c'
        },
        {
          id: 324,
          icon: <FactCheckIcon style={{padding: '5px', fontSize: '30px'}} />,
          text: 'General Discharge',
          className: `doctorsidebar${sidebarstate === 'General Discharge' ? ' activesidemenu' : ''}`,
          link: '/discharge-summary/general'
        },
        {
          id: 325,
          icon: <ContentPasteIcon style={{padding: '5px', fontSize: '30px'}} />,
          text: 'Other / Manual',
          className: `doctorsidebar${sidebarstate === 'Other / Manual' ? ' activesidemenu' : ''}`,
          link: '/discharge-summary/other'
        }
      ]
    },
    ...(userdata.role === 'Admin'
      ? [
          {
            id: 5,
            icon: <PersonAddIcon style={{padding: '10px', fontSize: '46px'}} />,
            text: 'User List',
            className: `doctorsidebar${sidebarstate === 'User List' ? ' activesidemenu' : ''}`,
            link: '/user_list'
          }
        ]
      : []),
    {
      id: 6,
      icon: <InventoryIcon style={{padding: '10px', fontSize: '46px'}} />,
      text: 'Drug Inventory',
      className: `doctorsidebar${sidebarstate === 'Drug Inventory' ? ' activesidemenu' : ''}`,
      link: '/druginventory'
    },
    ...(!isLab
      ? [
          {
            id: 7,
            icon: <HotelIcon style={{padding: '10px', fontSize: '46px'}} />,
            text: 'In-Patient & Beds',
            className: `doctorsidebar${sidebarstate === 'In-Patient & Beds' || location.pathname.startsWith('/inpatient') ? ' activesidemenu' : ''}`,
            subMenus: [
              {
                id: 701,
                icon: <HotelIcon style={{padding: '5px', fontSize: '30px'}} />,
                text: 'Bed Matrix',
                className: `doctorsidebar${sidebarstate === 'Bed Matrix' || location.pathname === '/inpatient' ? ' activesidemenu' : ''}`,
                link: '/inpatient'
              },
              {
                id: 702,
                icon: <FactCheckIcon style={{padding: '5px', fontSize: '30px'}} />,
                text: 'Admissions List',
                className: `doctorsidebar${sidebarstate === 'Admissions List' || location.pathname === '/inpatient/admissions' ? ' activesidemenu' : ''}`,
                link: '/inpatient/admissions'
              },
              {
                id: 703,
                icon: <BarChartIcon style={{padding: '5px', fontSize: '30px'}} />,
                text: 'IP Reports & ALOS',
                className: `doctorsidebar${sidebarstate === 'IP Reports & ALOS' || location.pathname === '/inpatient/reports' ? ' activesidemenu' : ''}`,
                link: '/inpatient/reports'
              },
              ...(isAdmin
                ? [
                    {
                      id: 705,
                      icon: <AdminPanelSettingsIcon style={{padding: '5px', fontSize: '30px'}} />,
                      text: 'System Audit Trail',
                      className: `doctorsidebar${sidebarstate === 'System Audit Trail' || location.pathname === '/inpatient/audit-log' ? ' activesidemenu' : ''}`,
                      link: '/inpatient/audit-log'
                    }
                  ]
                : [])
            ]
          }
        ]
      : []),
    {
      id: 71,
      icon: <MedicalServicesIcon style={{padding: '10px', fontSize: '46px'}} />,
      text: 'Operation Theatre',
      className: `doctorsidebar${sidebarstate === 'Operation Theatre' || location.pathname.startsWith('/ot') ? ' activesidemenu' : ''}`,
      subMenus: [
        ...(!isLab
          ? [
              {
                id: 711,
                icon: <EventIcon style={{padding: '5px', fontSize: '30px'}} />,
                text: "Today's OT List",
                className: `doctorsidebar${sidebarstate === "Today's OT List" || location.pathname === '/ot' ? ' activesidemenu' : ''}`,
                link: '/ot'
              },
              {
                id: 713,
                icon: <PlaylistAddCheckIcon style={{padding: '5px', fontSize: '30px'}} />,
                text: 'Overall Case List',
                className: `doctorsidebar${sidebarstate === 'Overall Case List' || location.pathname === '/ot/cases' ? ' activesidemenu' : ''}`,
                link: '/ot/cases'
              }
            ]
          : []),
        {
          id: 714,
          icon: <BiotechIcon style={{padding: '5px', fontSize: '30px'}} />,
          text: 'OT & OP Outsource Sample',
          className: `doctorsidebar${sidebarstate === 'OT & OP Outsource Sample' || location.pathname === '/ot/outsource' ? ' activesidemenu' : ''}`,
          link: '/ot/outsource'
        },
        {
          id: 715,
          icon: <QrCode2Icon style={{padding: '5px', fontSize: '30px'}} />,
          text: 'Barcode Generation',
          className: `doctorsidebar${sidebarstate === 'Barcode Generation' || location.pathname === '/ot/barcode' ? ' activesidemenu' : ''}`,
          link: '/ot/barcode'
        },
        ...(!isLab
          ? [
              {
                id: 716,
                icon: <TbReportAnalytics style={{padding: '5px', fontSize: '30px'}} />,
                text: 'OT Reports (NABH)',
                className: `doctorsidebar${sidebarstate === 'OT Reports (NABH)' || (sidebarstate === 'OT Report' && location.pathname.startsWith('/ot')) || location.pathname === '/ot/reports' ? ' activesidemenu' : ''}`,
                link: '/ot/reports'
              },
              {
                id: 717,
                icon: <WhatsAppIcon style={{padding: '5px', fontSize: '30px'}} />,
                text: 'WhatsApp Sharing',
                className: `doctorsidebar${sidebarstate === 'WhatsApp Sharing' || location.pathname === '/ot/whatsapp' ? ' activesidemenu' : ''}`,
                link: '/ot/whatsapp'
              }
            ]
          : []),
        ...(isAdmin || isDoctor
          ? [
              {
                id: 718,
                icon: <PaymentsIcon style={{padding: '5px', fontSize: '30px'}} />,
                text: 'Payout List',
                className: `doctorsidebar${sidebarstate === 'Payout List' || location.pathname === '/ot/payout' ? ' activesidemenu' : ''}`,
                link: '/ot/payout'
              }
            ]
          : []),
        ...(isAdmin
          ? [
              {
                id: 719,
                icon: <AdminPanelSettingsIcon style={{padding: '5px', fontSize: '30px'}} />,
                text: 'OT Administration',
                className: `doctorsidebar${sidebarstate === 'OT Administration' || location.pathname === '/ot/theatres' ? ' activesidemenu' : ''}`,
                link: '/ot/theatres'
              }
            ]
          : [])
      ]
    },
    {
      id: 72,
      icon: <EventIcon style={{padding: '10px', fontSize: '46px'}} />,
      text: 'Procedure List / Patient List',
      className: `doctorsidebar${sidebarstate === 'Procedure List / Patient List' ? ' activesidemenu' : ''}`,
      link: '/procedures'
    },
    {
      id: 8,
      icon: <EventIcon style={{padding: '10px', fontSize: '46px'}} />,
      text: 'Fertility',
      className: `doctorsidebar${sidebarstate === 'Fertility' ? ' activesidemenu' : ''}`,
      link: '/fertility'
    },
    {
      id: 30,
      icon: <BiotechIcon style={{padding: '10px', fontSize: '46px'}} />,
      text: 'IVF Lab',
      className: `doctorsidebar${sidebarstate === 'IVF Lab' ? ' activesidemenu' : ''}`,
      link: '/embryologist',
      subMenus: [
        {
          id: 301,
          icon: <BiotechIcon style={{padding: '5px', fontSize: '30px'}} />,
          text: 'Embryology',
          className: `doctorsidebar${sidebarstate === 'Embryology' ? ' activesidemenu' : ''}`,
          link: '/embryologist',
          subMenus: [
            {
              id: 3011,
              icon: <BiotechIcon style={{padding: '5px', fontSize: '30px'}} />,
              text: 'Embryo Tracking',
              className: `doctorsidebar${sidebarstate === 'Embryo Tracking' ? ' activesidemenu' : ''}`,
              link: '/embryologist/embryo-tracking'
            },
            {
              id: 3012,
              icon: <VaccinesIcon style={{padding: '5px', fontSize: '30px'}} />,
              text: 'Cryopreservation',
              className: `doctorsidebar${sidebarstate === 'Cryopreservation' ? ' activesidemenu' : ''}`,
              link: '/embryologist/cryo'
            },
            {
              id: 3013,
              icon: <FactCheckIcon style={{padding: '5px', fontSize: '30px'}} />,
              text: 'Embryology Register',
              className: `doctorsidebar${sidebarstate === 'Embryology Register' ? ' activesidemenu' : ''}`,
              link: '/embryologist/embryology-register'
            },
            {
              id: 3014,
              icon: <TbReportAnalytics style={{padding: '5px', fontSize: '30px'}} />,
              text: 'Embryology Reports',
              className: `doctorsidebar${sidebarstate === 'Embryology Reports' ? ' activesidemenu' : ''}`,
              link: '/embryologist/embryology-reports'
            }
          ]
        },
        {
          id: 302,
          icon: <ScienceIcon style={{padding: '5px', fontSize: '30px'}} />,
          text: 'Andrology',
          className: `doctorsidebar${sidebarstate === 'Andrology' ? ' activesidemenu' : ''}`,
          subMenus: [
            {
              id: 3021,
              icon: <TbReportAnalytics style={{padding: '5px', fontSize: '30px'}} />,
              text: 'Patient Reports',
              className: `doctorsidebar${sidebarstate === 'Patient Reports' ? ' activesidemenu' : ''}`,
              link: '/patientreports'
            }
          ]
        }
      ]
    },
    {
      id: 9,
      icon: <BarChartIcon style={{padding: '10px', fontSize: '46px'}} />,
      text: 'Report',
      className: `doctorsidebar${sidebarstate === 'Report' ? ' activesidemenu' : ''}`,
      link: '/reportDetails',
      subMenus: [
        {
          id: 10,
          icon: <LocalPharmacyIcon style={{padding: '5px', fontSize: '30px'}} />,
          text: 'Pharmacy',
          className: `doctorsidebar${sidebarstate === 'Pharmacy' ? ' activesidemenu' : ''}`,
          link: '/reportDetails/pharmacy'
        },
        {
          id: 11,
          icon: <ScannerIcon style={{padding: '5px', fontSize: '30px'}} />,
          text: 'Scan Report',
          className: `doctorsidebar${sidebarstate === 'Scan Report' ? ' activesidemenu' : ''}`,
          link: '/scan_report'
        },
        {
          id: 12,
          icon: <MedicalServicesIcon style={{padding: '5px', fontSize: '30px'}} />,
          text: 'Procedure Report',
          className: `doctorsidebar${sidebarstate === 'Procedure Report' ? ' activesidemenu' : ''}`,
          link: '/procedure_report'
        },
        {
          id: 13,
          icon: <PeopleAltIcon style={{padding: '5px', fontSize: '30px'}} />,
          text: 'Consultation Report',
          className: `doctorsidebar${sidebarstate === 'Consultation Report' ? ' activesidemenu' : ''}`,
          link: '/consultation_report'
        },
        {
          id: 14,
          icon: <VaccinesIcon style={{padding: '5px', fontSize: '30px'}} />,
          text: 'Injection Report',
          className: `doctorsidebar${sidebarstate === 'Injection Report' ? ' activesidemenu' : ''}`,
          link: '/Injection_report'
        },
        {
          id: 15,
          icon: <ContentPasteIcon style={{padding: '5px', fontSize: '30px'}} />,
          text: 'OT Report',
          className: `doctorsidebar${(sidebarstate === 'OT Report' && location.pathname === '/ot_report') ? ' activesidemenu' : ''}`,
          link: '/ot_report'
        }
      ]
    },
    {
      id: 16,
      icon: <InsertChartIcon style={{padding: '10px', fontSize: '46px'}} />,
      text: 'Charts',
      className: `doctorsidebar${sidebarstate === 'Charts' ? ' activesidemenu' : ''}`,
      link: '/charts',
      subMenus: [
        {
          id: 101,
          icon: <PregnantWomanIcon style={{padding: '5px', fontSize: '30px'}} />,
          text: 'An Chart',
          className: `doctorsidebar${sidebarstate === 'An Chart' ? ' activesidemenu' : ''}`,
          link: '/charts/An Chart'
        },
        {
          id: 18,
          icon: <FavoriteIcon style={{padding: '5px', fontSize: '30px'}} />,
          text: 'Blood Pressure Chart',
          className: `doctorsidebar${sidebarstate === 'Blood Pressure Chart' ? ' activesidemenu' : ''}`,
          link: '/charts/Blood Pressure Chart'
        },
        {
          id: 17,
          icon: <BloodtypeIcon style={{padding: '5px', fontSize: '30px'}} />,
          text: 'BP Sugar Chart',
          className: `doctorsidebar${sidebarstate === 'BP Sugar Chart' ? ' activesidemenu' : ''}`,
          link: '/charts/Bp Sugar Chart'
        },
        {
          id: 21,
          icon: <PaymentsIcon style={{padding: '5px', fontSize: '30px'}} />,
          text: 'Costing Sheet',
          className: `doctorsidebar${sidebarstate === 'Costing Sheet' ? ' activesidemenu' : ''}`,
          link: '/charts/Costing Sheet'
        },
        {
          id: 103,
          icon: <VolunteerActivismIcon style={{padding: '5px', fontSize: '30px'}} />,
          text: 'Donor Egg Costing',
          className: `doctorsidebar${sidebarstate === 'Donor Egg Costing' ? ' activesidemenu' : ''}`,
          link: '/charts/DONOR EGG PROGRAM'
        },
        {
          id: 24,
          icon: <PlaylistAddCheckIcon style={{padding: '5px', fontSize: '30px'}} />,
          text: 'Donor Stimulation Checklist',
          className: `doctorsidebar${sidebarstate === 'Donor Stimulation Checklist' ? ' activesidemenu' : ''}`,
          link: '/charts/DONOR STIMULATION CHECK LIST'
        },
        {
          id: 25,
          icon: <BiotechIcon style={{padding: '5px', fontSize: '30px'}} />,
          text: 'Fertility Investigation',
          className: `doctorsidebar${sidebarstate === 'Fertility Investigation' ? ' activesidemenu' : ''}`,
          link: '/charts/Fertility investigation'
        },
        {
          id: 104,
          icon: <PublishedWithChangesIcon style={{padding: '5px', fontSize: '30px'}} />,
          text: 'IVF / ICSI Re-evaluation',
          className: `doctorsidebar${sidebarstate === 'IVF / ICSI Re-evaluation' ? ' activesidemenu' : ''}`,
          link: '/charts/IVF ICSI RE-EVALUATION'
        },
        {
          id: 26,
          icon: <TroubleshootIcon style={{padding: '5px', fontSize: '30px'}} />,
          text: 'IVF Failure Investigations',
          className: `doctorsidebar${sidebarstate === 'IVF Failure Investigations' ? ' activesidemenu' : ''}`,
          link: '/charts/IVF Failure Investigations'
        },
        {
          id: 19,
          icon: <ChildCareIcon style={{padding: '5px', fontSize: '30px'}} />,
          text: 'Kick Count Chart',
          className: `doctorsidebar${sidebarstate === 'Kick Count Chart' ? ' activesidemenu' : ''}`,
          link: '/charts/Kick Count Chart'
        },
        {
          id: 20,
          icon: <RunningWithErrorsIcon style={{padding: '5px', fontSize: '30px'}} />,
          text: 'Preterm Labour',
          className: `doctorsidebar${sidebarstate === 'Preterm Labour' ? ' activesidemenu' : ''}`,
          link: '/charts/Preterm Labour'
        },
        {
          id: 22,
          icon: <ScienceIcon style={{padding: '5px', fontSize: '30px'}} />,
          text: 'RPL Investigation Basic',
          className: `doctorsidebar${sidebarstate === 'RPL Investigation Basic' ? ' activesidemenu' : ''}`,
          link: '/charts/RPL Investigation Basic'
        },
        {
          id: 23,
          icon: <BiotechIcon style={{padding: '5px', fontSize: '30px'}} />,
          text: 'RPL Investigation Extensive',
          className: `doctorsidebar${sidebarstate === 'RPL Investigation Extensive' ? ' activesidemenu' : ''}`,
          link: '/charts/RPL Investigation Extensive'
        },
        {
          id: 102,
          icon: <FactCheckIcon style={{padding: '5px', fontSize: '30px'}} />,
          text: 'Stimulation Starting Checklist',
          className: `doctorsidebar${sidebarstate === 'Stimulation Starting Checklist' ? ' activesidemenu' : ''}`,
          link: '/charts/STIMULATION STARTING CHECKLIST'
        },
        {
          id: 103,
          icon: <VaccinesIcon style={{padding: '5px', fontSize: '30px'}} />,
          text: 'Injection Chart',
          className: `doctorsidebar${sidebarstate === 'Injection Chart' ? ' activesidemenu' : ''}`,
          link: '/charts/Injection Chart'
        },
        {
          id: 104,
          icon: <MonitorHeartIcon style={{padding: '5px', fontSize: '30px'}} />,
          text: 'IVF Follicular Monitoring',
          className: `doctorsidebar${sidebarstate === 'IVF Follicular Monitoring' ? ' activesidemenu' : ''}`,
          link: '/charts/IVF FOLLICULAR MONITORING'
        }
      ]
    }
  ];

  // Sync sidebar state with URL path
  useEffect(() => {
    const rawPath = decodeURIComponent(location.pathname);
    const currentPath = rawPath.replace(/\/+$/, '') || '/';

    const findItemByPath = items => {
      for (const item of items) {
        if (item.subMenus) {
          const nestedItem = findItemByPath(item.subMenus);
          if (nestedItem) return nestedItem;
        }
        const itemLinkNorm = item.link ? item.link.replace(/\/+$/, '') || '/' : '';
        if (itemLinkNorm === currentPath) return item;
      }
      return null;
    };

    const matchedItem = findItemByPath(navData);
    if (matchedItem) dispatch(sidebar(matchedItem.text));
  }, [location.pathname, dispatch]);

  // Collect all submenu texts and their indices for expand logic
  const submenuMap = {};
  const collectSubmenuMap = (items, parentKey = '') => {
    items.forEach((item, index) => {
      const key = parentKey ? `${parentKey}-${index}` : `${index}`;
      if (item.subMenus) {
        item.subMenus.forEach(sub => {
          submenuMap[sub.text] = key;
          if (sub.link) {
            submenuMap[sub.link] = key;
            submenuMap[sub.link.replace(/\/+$/, '') || '/'] = key;
          }
        });
        collectSubmenuMap(item.subMenus, key);
      }
    });
  };
  collectSubmenuMap(navData);

  const sidebarHandleClick = text => {
    if (text !== 'Settings' && text !== 'Diagnostics') {
      dispatch(sidebar(text));
    }
    dispatch(dvtabs('About'));
  };

  const onMouseEnter = () => {
    if (!sideactive) {
      $('.sidebarclose').css('width', '240px');
      $('.linkTextclosed').css('display', 'block');
      $('.arrow').css('display', 'block');
      const currentPath = decodeURIComponent(location.pathname).replace(/\/+$/, '') || '/';
      const activeKey = submenuMap[currentPath] || submenuMap[sidebarstate];
      if (activeKey !== undefined) {
        setExpand(prev => ({
          ...prev,
          ...activeKey.split('-').reduce((acc, _part, index, parts) => {
            acc[parts.slice(0, index + 1).join('-')] = true;
            return acc;
          }, {})
        }));
      }
    }
  };

  const onMouseLeave = () => {
    if (!sideactive) {
      $('.sidebarclose').css('width', '65px');
      $('.linkTextclosed').css('display', 'none');
      $('.arrow').css('display', 'none');
      setExpand({});
    }
  };

  useEffect(() => {
    if (!sideactive) setExpand({});
  }, [sideactive]);

  useEffect(() => {
    const currentPath = decodeURIComponent(location.pathname).replace(/\/+$/, '') || '/';
    const activeKey = submenuMap[currentPath] || submenuMap[sidebarstate];
    if (sideactive && activeKey !== undefined) {
      setExpand(prev => ({
        ...prev,
        ...activeKey.split('-').reduce((acc, _part, index, parts) => {
          acc[parts.slice(0, index + 1).join('-')] = true;
          return acc;
        }, {})
      }));
    }
  }, [sideactive, location.pathname]);

  const toggleExpand = key => {
    setExpand(prev => ({...prev, [key]: !prev[key]}));
  };

  const renderNavItem = (item, key) => {
    if (!item.icon) return null;

    const hasSubMenus = Boolean(item.subMenus?.length);
    const itemBody = (
      <li
        className={`sideitem row ${item.className}`}
        onClick={() => {
          sidebarHandleClick(item.text);
          if (hasSubMenus) toggleExpand(key);
        }}>
        <div className='col-2' style={{width: '65px'}}>
          {item.icon}
        </div>
        <div className={sideactive ? 'linkText col-6' : 'linkTextclosed col-6'}>
          <span className='nav-link'>{item.text}</span>
        </div>
        {hasSubMenus && (
          <i
            className={`bi bi-caret-right-fill arrow col-2${expand[key] ? ' arrowexpand' : ''}`}
            style={{display: sideactive ? 'block' : 'none', marginLeft: '10px'}}
            onClick={e => {
              e.preventDefault();
              e.stopPropagation();
              toggleExpand(key);
            }}></i>
        )}
      </li>
    );

    return (
      <div key={item.id}>
        {item.link ? (
          <NavLink to={item.link} style={{textDecoration: 'none'}}>
            {itemBody}
          </NavLink>
        ) : (
          itemBody
        )}

        {hasSubMenus && (
          <ul className={`sub-menu ${key} ${expand[key] ? 'activeside' : ''}`}>
            {item.subMenus.map((subItem, subIndex) => renderNavItem(subItem, `${key}-${subIndex}`))}
          </ul>
        )}
      </div>
    );
  };

  return (
    <div className={sideactive ? 'sidebar' : 'sidebarclose'} id='sidebar' onMouseEnter={onMouseEnter} onMouseLeave={onMouseLeave}>
      <div className='sidebar-inner slimscroll'>
        <div id='sidebar-menu' className='sidebar-menu'>
          <ul className='sidebar_content'>
            {navData.map((item, index) => renderNavItem(item, `${index}`))}
          </ul>
        </div>
      </div>
    </div>
  );
}

export default SideBar;

